<div class="tracker-main padding_top0 vh-100start">
    <div class="container start-container">
        <div class="row align-items-center">
            <div class="col-sm-12">
             <div class="card py-1 p-3 ">
                <h2 class="welcometxt clrblue pt-3" translate>lblWelcome</h2>
                <div class="container center" style="width:auto; max-width: 1000px; margin:50px 0" >
                    <img class="brand" src="../../../../assets/images/autofacets.png" alt="Logo" />
                </div>
                <h2 class="welcometxt pt-3" translate>lblUnauthorizePageAccess</h2>
             </div>

            </div>

        </div>
    </div>
</div>